module.exports = __webpack_public_path__ + "media/images/icons/outlined/border-left-5fb42ed32ba3fffebc13c33f45226053.svg";